module.exports = __webpack_public_path__ + "img/asp.bf986cbb.svg";